import {OrderResponse} from '../lib/order-types';
import {employeeSigninResponse} from '../lib/types';

type StoreMetaData = {
  name: string;
  value: string;
};
type StoreInformationData = {
  resultCode: string;
  message: string;
  result: boolean;
  entity: string;
  store_code: string;
  store_name: string;
  pincode: string;
  latitude: string;
  longitude: string;
  server_ip: string;
  store_open_timings: string;
  store_close_timing: string;
};
export type searchUser = {
  result: boolean;
  resultCode: string;
  message: string;
  firstName: string;
  tier: string;
  pointsAvailable: number;
  pointToExpire: number;
  cardNumber: string;
  lastName: string | null;
  email: string;
  dob: string;
  gender: string;
  validity: Date | null;
};

type user = {
  resultCode: string;
  message: string;
  result: boolean;
  cardNumber: string;
  firstName: string;
  lastName: string;
};
export type CustomerCoupon = {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
};
type CouponPoints = {
  tier: string | null;
  message: string;
  firstName: string | null;
  redirectUrl: string | null;
  pointsAvailable: number;
  pointsToExpire: number;
  firstScan: null;
  date: string | null;
  keyId: string | null;
  benefit: null;
  firstLogin: string | null;
  showEdge: boolean;
  customerCoupons: CustomerCoupon[] | null;
  spinWheelPoints: null;
  interactionBenefit: null;
  resultType: string;
};

type ItemDea = {
  itemDetail: ItemDetail[] | null;
};

type ItemDetail = {
  itemID: string;
  itemDesc: string;
  itemDept: string;
  itemBrand: string;
  itemColour: string;
  itemSize: string;
  mmrpFlag: string;
  priceList: PriceList[] | null;
};

type PriceList = {
  sellPrice: number;
  discountAmount: number;
  extSellPrice: number;
  promoList: PromoList[] | null;
};
type PromoList = {
  discountAmount: number;
  promoDesc: string;
  promoID: string;
};
type GiftCouponList = {
  discountAmount?: number;
  couponDesc?: string;
  couponID?: string;
};

type CouponItemList = {
  itemIdentifier: string;
  discountAmount: number;
  extSellPrice: number;
  itemID: string;
  giftCouponList: GiftCouponList[];
  quantity: number;
  sellPrice: number;
};

type ApplyCouponResponse = {
  statusCode: string;
  message: string;
  storeID: string;
  orderID: string;
  itemList: CouponItemList[];
};
export const setAccessToken = (token: string): void => {
  const access_token = token;
  const encodedAccessToken = btoa(access_token);
  localStorage.setItem('access_token', encodedAccessToken);
};

export const setStoreCode = (storeCode: string): void => {
  const encodedStoreCode = btoa(storeCode);
  localStorage.setItem('store_code', encodedStoreCode);
};

export const setStoreInformation = (
  storeInformationData: StoreInformationData,
): void => {
  const encodedStoreInformation = btoa(JSON.stringify(storeInformationData));
  localStorage.setItem('store_information', encodedStoreInformation);
};

export const getAccessToken = () => {
  const accessToken = localStorage.getItem('access_token');
  let decodedAccessToken = null;
  if (accessToken != null) {
    decodedAccessToken = atob(accessToken);
  }
  return decodedAccessToken;
};

export const getStoreCode = () => {
  const storeCode = localStorage.getItem('store_code');
  let decodedStoreCode = null;
  if (storeCode != null) {
    decodedStoreCode = atob(storeCode);
  }
  return decodedStoreCode;
};

export const getStoreInformation = () => {
  const storeInformation = localStorage.getItem('store_information');
  let decodedStoreInformation = null;
  if (storeInformation != null) {
    decodedStoreInformation = JSON.parse(atob(storeInformation));
  }
  return decodedStoreInformation;
};
export const setPhoneNumber = (phoneNumber: string): void => {
  const mobileNumber = phoneNumber;
  const encodedAccessToken = btoa(mobileNumber);
  localStorage.setItem('mobileNumber', encodedAccessToken);
};

export const getPhoneNumber = () => {
  const accessToken = localStorage.getItem('mobileNumber');
  let decodedAccessToken = null;
  if (accessToken != null) {
    decodedAccessToken = atob(accessToken);
  }
  return decodedAccessToken;
};

export const setUser = (users: user): void => {
  const Users = btoa(JSON.stringify(users));
  localStorage.setItem('users', Users);
};

export const setSearchUser = (users: searchUser): void => {
  const Users = btoa(JSON.stringify(users));
  localStorage.setItem('users', Users);
};
export const getUser = () => {
  const Users = localStorage.getItem('users');
  let decodedUsersData = null;
  if (Users != null) {
    decodedUsersData = JSON.parse(atob(Users));
  }
  return decodedUsersData;
};

export const setCouponPointsDetails = (
  couponPointsData: CustomerCoupon[],
): void => {
  const encodedCouponPointsDetails = btoa(JSON.stringify(couponPointsData));
  localStorage.setItem('coupon_point_details', encodedCouponPointsDetails);
};

export const getCouponPointsDetails = () => {
  const couponPointsDetails = localStorage.getItem('coupon_point_details');
  let decodedCouponPointsDetails = null;
  if (couponPointsDetails != null) {
    decodedCouponPointsDetails = JSON.parse(atob(couponPointsDetails));
  }
  return decodedCouponPointsDetails;
};

export const setCustomerCouponsCountinLS = (count: number): void => {
  const encodedCount = btoa(JSON.stringify(count));
  localStorage.setItem('coupon_count_number', encodedCount);
};

export const getCustomerCouponsCountinLS = () => {
  const count = localStorage.getItem('coupon_count_number');
  let decodedCount = null;
  if (count != null) {
    decodedCount = JSON.parse(atob(count));
  }
  return decodedCount;
};

// export const setBagItemInformation = (itemInformation: ItemInformation[]) => {
//   const encodedItemInformation = btoa(JSON.stringify(itemInformation));
//   localStorage.setItem('bag_item_information', encodedItemInformation);
// };

// export const getBagItemInformation = () => {
//   const itemInformation = localStorage.getItem('bag_item_information');
//   let decodedItemInformation = null;
//   if (itemInformation != null) {
//     decodedItemInformation = JSON.parse(atob(itemInformation));
//   }
//   return decodedItemInformation;
// };

export const setAllOffers = (updatedOffers: CustomerCoupon[]): void => {
  const encodedAllOffers = btoa(JSON.stringify(updatedOffers));
  localStorage.setItem('all_offers', encodedAllOffers);
};

export const getAllOffers = () => {
  const allOffers = localStorage.getItem('all_offers');
  let decodedAllOffers = null;
  if (allOffers != null) {
    decodedAllOffers = JSON.parse(atob(allOffers));
  }
  return decodedAllOffers;
};

export const setTourGuide = (status: boolean): void => {
  const tourGuideStatus = btoa(JSON.stringify(status));
  localStorage.setItem('tourGuide', tourGuideStatus);
};

export const getTourGuideStatus = () => {
  //const tourGuideStatus = btoa(JSON.stringify(status));
  const tourStatus = localStorage.getItem('tourGuide');
  let tourGuideData = null;
  if (tourStatus != null) {
    tourGuideData = JSON.parse(atob(tourStatus));
  }
  return tourGuideData;
};

export const setSignUp = (): void => {
  const tourGuideStatus = btoa(JSON.stringify('true'));
  localStorage.setItem('signup', tourGuideStatus);
};

export const getSignUp = () => {
  //const tourGuideStatus = btoa(JSON.stringify(status));
  const tourStatus = localStorage.getItem('signup');
  let tourGuideData = null;
  if (tourStatus != null) {
    tourGuideData = JSON.parse(atob(tourStatus));
  }

  return tourGuideData;
};

export const setTempPassword = (): void => {
  const tempPassword = btoa(JSON.stringify('true'));
  localStorage.setItem('tempPassword', tempPassword);
};

export const getTempPassword = () => {
  //const tourGuideStatus = btoa(JSON.stringify(status));
  const checkTempPassword = localStorage.getItem('tempPassword');
  let checkpassword = null;
  if (checkTempPassword != null) {
    checkpassword = JSON.parse(atob(checkTempPassword));
  }

  return checkpassword;
};

export const setpaymentConfirm = (): void => {
  const payment = btoa(JSON.stringify('true'));
  localStorage.setItem('thankyoumessage', payment);
};

export const getPaymentonfirm = () => {
  //const tourGuideStatus = btoa(JSON.stringify(status));
  const paymentData = localStorage.getItem('thankyoumessage');
  let paymentStatus = null;
  if (paymentData != null) {
    paymentStatus = JSON.parse(atob(paymentData));
  }

  return paymentStatus;
};

export const setItemSearchData = (itemsearchData: ItemDetail[]): void => {
  const encodedItemSearchDetails = btoa(JSON.stringify(itemsearchData));
  localStorage.setItem('item_search_details', encodedItemSearchDetails);
};

export const getItemSearchData = () => {
  const itemDetails = localStorage.getItem('item_search_details');
  let decodeditemDetails = null;
  if (itemDetails != null) {
    decodeditemDetails = JSON.parse(atob(itemDetails));
  }
  return decodeditemDetails;
};

export const setOrderID = (orderID: string): void => {
  const encodedStoreCode = btoa(orderID);
  localStorage.setItem('order_ID', encodedStoreCode);
};

export const getOrderID = () => {
  const accessOrderID = localStorage.getItem('order_ID');
  let decodedOrderID = null;
  if (accessOrderID != null) {
    decodedOrderID = atob(accessOrderID);
  }
  return decodedOrderID;
};

export const setUserType = (usetType: string): void => {
  const encodedStoreCode = btoa(usetType);
  localStorage.setItem('userType', encodedStoreCode);
};

export const getUserType = () => {
  const getUserstatus = localStorage.getItem('userType');
  let userData = null;
  if (getUserstatus != null) {
    userData = atob(getUserstatus);
  }
  return userData;
};

export const setStoreLatitude = (latitude: string) => {
  const encodedStoreLatitude = btoa(latitude);
  localStorage.setItem('store_latitude', encodedStoreLatitude);
};

export const getStoreLatitude = () => {
  const storeLati = localStorage.getItem('store_latitude');
  let decodedStoreLati = null;
  if (storeLati != null) {
    decodedStoreLati = atob(storeLati);
  }
  return decodedStoreLati;
};

export const setStoreLongitude = (longitude: string) => {
  const encodedStoreLong = btoa(longitude);
  localStorage.setItem('store_longitude', encodedStoreLong);
};

export const getStoreLongitude = () => {
  const storeLong = localStorage.getItem('store_longitude');
  let decodedStoreLong = null;
  if (storeLong != null) {
    decodedStoreLong = atob(storeLong);
  }
  return decodedStoreLong;
};

export const setSize = (productsize: string): void => {
  const encodedStoreCode = btoa(productsize);
  localStorage.setItem('size', encodedStoreCode);
};

export const getSize = () => {
  const getSizestatus = localStorage.getItem('size');
  let getSizeData = null;
  if (getSizestatus != null) {
    getSizeData = atob(getSizestatus);
  }
  return getSizeData;
};
export const setColor = (productcolor: string): void => {
  const encodedStoreCode = btoa(productcolor);
  localStorage.setItem('color', encodedStoreCode);
};

export const getColor = () => {
  const getColorstatus = localStorage.getItem('color');
  let userData = null;
  if (getColorstatus != null) {
    userData = atob(getColorstatus);
  }
  return userData;
};

export const setAppliedCoupon = (
  appliedCouponResponse: ApplyCouponResponse,
): void => {
  const encodedAppliedCouponResponse = btoa(
    JSON.stringify(appliedCouponResponse),
  );
  localStorage.setItem('applied_coupon', encodedAppliedCouponResponse);
};

export const getAppliedCoupon = () => {
  const appliedCouponResponse = localStorage.getItem('applied_coupon');
  let decodedAppliedCouponResponse = null;
  if (appliedCouponResponse != null) {
    decodedAppliedCouponResponse = JSON.parse(atob(appliedCouponResponse));
  }
  return decodedAppliedCouponResponse;
};

export const setMetadata = (StoreMetaData: StoreMetaData): void => {
  const encodedMetadata = btoa(JSON.stringify(StoreMetaData));
  localStorage.setItem('metadata', encodedMetadata);
};
export const getMetadata = () => {
  const metaData = localStorage.getItem('metadata');
  let decodedMetadata = null;
  if (metaData != null) {
    decodedMetadata = JSON.parse(atob(metaData));
  }
  return decodedMetadata;
};

// export const getUser = () => {};
export const getMoengageData = () => {
  const getData = localStorage.getItem('MOE_DATA');
  //console.log(getData);
  let data = null;
  if (getData != null) {
    data = JSON.parse(getData);
    if (
      data.USER_DATA === undefined ||
      data.USER_DATA.attributes === undefined
    ) {
      return null;
    }
    if (
      data.USER_DATA.attributes != null &&
      data.USER_DATA.attributes[5] != null
    ) {
      return true;
    }
  }
  return null;
};
export const setTotalCartItems = (count: number): void => {
  const encodedTotalCartItems = btoa(JSON.stringify(count));
  localStorage.setItem('total_cart_items', encodedTotalCartItems);
};
export const getTotalCartItems = () => {
  const totalCartItems = localStorage.getItem('total_cart_items');
  let decodedTotalCartItems = null;
  if (totalCartItems != null) {
    decodedTotalCartItems = JSON.parse(atob(totalCartItems));
  }
  return decodedTotalCartItems;
};

export const setStartTime = (date: string): void => {
  const CurrentDate = date;
  const encodedAccessToken = btoa(CurrentDate);
  localStorage.setItem('startTime', encodedAccessToken);
};

export const getStartTime = () => {
  const accessToken = localStorage.getItem('startTime');
  let decodedAccessToken = null;
  if (accessToken != null) {
    decodedAccessToken = atob(accessToken);
  }
  return decodedAccessToken;
};

export const setStoreEmployeeInfo = (employeeInfo: employeeSigninResponse) => {
  const employee = btoa(JSON.stringify(employeeInfo));
  localStorage.setItem('employee', employee);
};

export const getStoreEmployeeInfo = () => {
  const employeeData = localStorage.getItem('employee');
  let decodedEmplouyeeData = null;
  if (employeeData != null) {
    decodedEmplouyeeData = JSON.parse(atob(employeeData));
  }
  return decodedEmplouyeeData;
};

export const setThankyou = (): void => {
  const thankyou = btoa(JSON.stringify('true'));
  localStorage.setItem('thankyou', thankyou);
};

export const getThankyou = () => {
  //const tourGuideStatus = btoa(JSON.stringify(status));
  const thankyouStatus = localStorage.getItem('thankyou');
  let thankyouData = null;
  if (thankyouStatus != null) {
    thankyouData = JSON.parse(atob(thankyouStatus));
  }

  return thankyouData;
};

export const setLmrFirstStatus = (status: string) => {
  const encodedStoreLong = btoa(status);
  localStorage.setItem('_storeStatus', encodedStoreLong);
};
export const getLmrFirstStatus = () => {
  const statusData = localStorage.getItem('_storeStatus');
  let status = null;
  if (statusData != null) {
    status = JSON.parse(atob(statusData));
  }

  return status;
};
export const setLmrUserStatus = (status: string) => {
  const encodedStoreLong = btoa(status);
  localStorage.setItem('_userStatus', encodedStoreLong);
};
export const getLmrUserStatus = () => {
  const statusData = localStorage.getItem('_userStatus');
  let status = null;
  if (statusData != null) {
    status = JSON.parse(atob(statusData));
  }

  return status;
};

export const setCheckSum = (status: string) => {
  //const encodedStoreLong = btoa(status);
  localStorage.setItem('checksum', status);
};
export const getCheckSum = () => {
  const statusData = localStorage.getItem('checksum');
  let status = null;
  if (statusData != null) {
    status = statusData;
  }

  return status;
};

export const setLmrCheck = (status: boolean) => {
  const temp = status.toString();
  const encodedStoreLong = btoa(temp);
  localStorage.setItem('lmrchecked', encodedStoreLong);
};
export const getLmrChecked = () => {
  const statusData = localStorage.getItem('lmrchecked');
  let status = null;
  if (statusData != null) {
    status = JSON.parse(atob(statusData));
  }

  return status;
};

export const setLandedFirstTimeCount = (count: number) => {
  const encodedCount = btoa(JSON.stringify(count));
  localStorage.setItem('eliteStatusCoint', encodedCount);
};

export const getLandedFirstTimeCount = () => {
  const count = localStorage.getItem('eliteStatusCoint');
  let decodedCount = null;
  if (count != null) {
    decodedCount = JSON.parse(atob(count));
  }
  return decodedCount;
};

export const setOrderResp = (order: OrderResponse | null): void => {
  const encodedStoreCode = btoa(JSON.stringify(order));
  localStorage.setItem('order_Resp', encodedStoreCode);
};

export const getOrderResp = () => {
  const accessOrderID = localStorage.getItem('order_Resp');
  let decodedOrderID = null;
  if (accessOrderID != null) {
    decodedOrderID = JSON.parse(atob(accessOrderID));
  }
  return decodedOrderID;
};
